import { render, staticRenderFns } from "./ShopProductGroupbuy.vue?vue&type=template&id=3701ec1c&scoped=true"
import script from "./ShopProductGroupbuy.vue?vue&type=script&lang=js"
export * from "./ShopProductGroupbuy.vue?vue&type=script&lang=js"
import style0 from "./ShopProductGroupbuy.vue?vue&type=style&index=0&id=3701ec1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701ec1c",
  null
  
)

export default component.exports